import React, { Component } from "react";
import "./cmdStatusReport.css";
import InMultiSelect from "../InMultiSelect/InMultiSelect";
import GroupTable from "../GroupReport/groupTable";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import { dateFormat } from "../../../../constants/constants";
import moment from "moment";
import { connect } from 'react-redux';
import { Logger } from "sass";
import { JSONToCSVConvertor } from "../../../../helpers/helperFunctions";


class CmdStatusReport extends Component{
    constructor(props){
        super(props)
        this.props = props
    this.state = {
      busy: false,
        }
        this.tableData = []
    this.selectedCols = [
            {key:"vehicleno", name: "Vehicle No"},
            {key: "cmdstatus", name: "Status"},
            {key: "cmdid", name: "Command Id"},
            {key: "cmd_type", name: "Command Type"},
            {key: "cmdsrc", name: "Command Source"},
            {key: "createdby", name: "Created By"},
            {key: "timestamp", name: "Time"},

        ]
  }
  changeVehicle = function (v) {
    window.saveVehicleState(v);
    // this.vehicleSelect.wrappedInstance.setFocusActive();
    this.vehicleSelect?.setFocusActive();
  };

  getCmdStatus = () => {
    this.tableData = [];
    this.setState({ busy: true });
    let vehiclenos = [];
    if (window.selectedItems && window.selectedItems.length !== 0) {
      for (let idx in window.selectedItems) {
        vehiclenos.push(window.selectedItems[idx].data.vehicleno);
      }
    } else if (
      window.selectedItems === undefined &&
      window.selectedVehicles &&
      window.selectedVehicles[0]
    ) {
      vehiclenos.push(window.selectedVehicles[0].data.vehicleno);
    }
    if (vehiclenos && vehiclenos.length === 0) {
      this.props.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Please select a vehicle",
          content: "Please select a vehicle",
          createAt: Date.now(),
          autoClose: 8000,
          showError: true,
        },
      });
      this.setState({ busy: false });
      return;
    }
    let body = {
      vehiclenos: vehiclenos,
    };
    ReportAPIs.latestCmdStatusReport(body)
      .then((resp) => {
        for (let idx in resp) {
          let status = resp[idx];
          let obj = {};
          if (status.cmdStatus !== null) {
            obj.vehicleno = status.vehicleno;
            obj.cmdid = status.cmdStatus.cmdid;
            obj.cmd_type = status.cmdStatus.cmd.type;
            obj.cmdsrc = status.cmdStatus.cmdsrc;
            obj.createdby = status.cmdStatus.createdby;

            let currentStatus = status.cmdStatus.status;
            if (currentStatus.length > 1) {
              const latestStatus = currentStatus.sort(
                (a, b) => b.timestamp - a.timestamp
              );
              obj.cmdstatus = latestStatus[0].cmdstatus;
              obj.timestamp = moment(latestStatus[0].timestamp).format(
                dateFormat
              );
            } else {
              obj.cmdstatus = currentStatus[0].cmdstatus;
              obj.timestamp = moment(currentStatus[0].timestamp).format(
                dateFormat
              );
            }

            this.tableData.push(obj);
          }
        }
        this.setState({ busy: false });
      })
      .catch(() => {
        this.setState({ busy: false });
      });
  };

  handleDownload = (event) => {
    // Check if dropdown already exists and remove it
    const existingDropdown = document.getElementById("download-dropdown");
    if (existingDropdown) {
      existingDropdown.remove();
      return;
    }

    // If vehicleList.length >= 2000, directly download current data
    if (
      this.props.vehicleMap &&
      Object.keys(this.props.vehicleMap).length >= 2000
    ) {
      this.downloadCurrentData();
      return;
    }

    // Create dropdown container
    const dropdown = document.createElement("div");
    dropdown.id = "download-dropdown";
    dropdown.style.cssText = `
      position: fixed;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
      z-index: 9999;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #ccc;
      min-width: 150px;
    `;

    // Create dropdown options
    const options = [
      {
        text: "Download",
        action: () => this.downloadCurrentData(),
      },
      {
        text: "Download All",
        action: () => this.downloadAllData(),
      },
    ];

    // Add options to dropdown
    options.forEach((option) => {
      const optionElement = document.createElement("div");
      optionElement.style.cssText = `
        padding: 8px 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #333;
        font-size: 14px;
        white-space: nowrap;
      `;

      optionElement.innerHTML = `<span>${option.text}</span>`;

      optionElement.addEventListener("click", () => {
        option.action();
        dropdown.remove();
      });

      optionElement.addEventListener("mouseenter", () => {
        optionElement.style.backgroundColor = "#f5f5f5";
      });

      optionElement.addEventListener("mouseleave", () => {
        optionElement.style.backgroundColor = "transparent";
      });

      dropdown.appendChild(optionElement);
    });

    // Position dropdown near the download button
    const downloadButton =
      event.target.closest(".get-download") || event.target;
    if (downloadButton) {
      const rect = downloadButton.getBoundingClientRect();

      document.body.appendChild(dropdown);
      const dropdownWidth = dropdown.offsetWidth;
      const dropdownHeight = dropdown.offsetHeight;

      let left = rect.left;
      let top = rect.bottom + 5;

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      if (left + dropdownWidth > viewportWidth) {
        left = viewportWidth - dropdownWidth - 10;
      }
      if (top + dropdownHeight > viewportHeight) {
        top = rect.top - dropdownHeight - 5;
      }
      if (top < 0) {
        top = 10;
      }

      dropdown.style.left = `${left}px`;
      dropdown.style.top = `${top}px`;

      // Close dropdown when clicking outside
      const clickHandler = (e) => {
        if (!dropdown.contains(e.target) && e.target !== downloadButton) {
          dropdown.remove();
          document.removeEventListener("click", clickHandler);
        }
      };

      setTimeout(() => {
        document.addEventListener("click", clickHandler);
      }, 10);
    }
  };

  downloadCurrentData = () => {
    const csvData = this.tableData.map((row) => ({
      "Vehicle No": row.vehicleno,
      "Command Id": row.cmdid,
      "Command Type": row.cmd_type,
      "Command Source": row.cmdsrc,
      "Created By": row.createdby,
        "Status": row.cmdstatus,
        "Time": row.timestamp
    }));

    JSONToCSVConvertor(csvData, "Cmd_Status_Report", true);
  };

  downloadAllData = () => {
    // Get all vehicles from vehicleMap
    const vehicleMap = this.props.vehicleMap || {};
    const allVehicles = Object.values(vehicleMap)
      .filter(
        (vehicle) =>
          vehicle && vehicle.vehicleno && !vehicle.vehicleno.includes("user")
      )
      .map((vehicle) => vehicle.vehicleno);

    if (allVehicles.length === 0) {
      this.props.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "No vehicles available",
          content: "No vehicles found to download data for",
          createAt: Date.now(),
          autoClose: 8000,
          showError: true,
        },
      });
      return;
    }

    // Show loading state
    this.setState({ busy: true });

    // Make API call for all vehicles
    let body = {
      vehiclenos: allVehicles,
    };

    ReportAPIs.latestCmdStatusReport(body)
      .then((resp) => {
        const allData = [];

        for (let idx in resp) {
          let status = resp[idx];
          let obj = {};
          if (status.cmdStatus !== null) {
            obj.vehicleno = status.vehicleno;
            obj.cmdid = status.cmdStatus.cmdid;
            obj.cmd_type = status.cmdStatus.cmd.type;
            obj.cmdsrc = status.cmdStatus.cmdsrc;
            obj.createdby = status.cmdStatus.createdby;

            let currentStatus = status.cmdStatus.status;
            if (currentStatus.length > 1) {
              const latestStatus = currentStatus.sort(
                (a, b) => b.timestamp - a.timestamp
              );
              obj.cmdstatus = latestStatus[0].cmdstatus;
              obj.timestamp = moment(latestStatus[0].timestamp).format(
                dateFormat
              );
            } else {
              obj.cmdstatus = currentStatus[0].cmdstatus;
              obj.timestamp = moment(currentStatus[0].timestamp).format(
                dateFormat
              );
            }

            allData.push(obj);
            // this.tableData.push(obj);
          }
        }
        
        // Download all data
        const csvData = allData.map((row) => ({
          "Vehicle No": row.vehicleno,
          "Command Id": row.cmdid,
          "Command Type": row.cmd_type,
          "Command Source": row.cmdsrc,
          "Created By": row.createdby,
          Status: row.cmdstatus,
          Time: row.timestamp,
        }));

        JSONToCSVConvertor(csvData, "Cmd_Status_Report_All", true);

        this.setState({ busy: false });
        this.props.dispatch({
            type: "ADD_INTOAST",
            data: {
              name: "Download Success",
              content: "Successfully download all vehicle data",
              createAt: Date.now(),
              autoClose: 8000,
              showError: true,
            },
          });
      })
      .catch((error) => {
        this.setState({ busy: false });
        this.props.dispatch({
          type: "ADD_INTOAST",
          data: {
            name: "Download Failed",
            content: "Failed to download all data",
            createAt: Date.now(),
            autoClose: 8000,
            showError: true,
          },
        });
      });
  };

  render() {
    const vehicleMap = this.props.vehicleMap || {};
    const vehicleList = Object.values(vehicleMap)
      .filter(
        (vehicle) =>
          vehicle && vehicle.vehicleno && !vehicle.vehicleno.includes("user")
      )
      .map((vehicle) => vehicle.vehicleno);
    return (
      <div className="statusContainer">
        <div className="header">
        <div style={{display:"flex"}}>
            <div className="vehicleSelection">
            <InMultiSelect
                    ref={ref => { this.vehicleSelect = ref; }}
                    data={{  storeData: (state) => {
                    return {
                      data: (() => {
                        let newMap = {};
                        for (let idx in state.vehicleMap) {
                          if (idx.indexOf("user") === -1) {
                            newMap[idx] = state.vehicleMap[idx];
                          }
                        }
                        return newMap;
                      })(),
                      name: "vehicleno",
                      id: "vehicleid",
                    };
                  },
                  key: "vehicle",
                  singleSelect: false,
                  onItemChange: this.changeVehicle.bind(this),
                  schemaKey: "cmd_status_report",
                  defaultValue: () => {
                    return {
                      data: window.selectedVehicles.map((i) => {
                        return i.id;
                      }),
                      updatedAt: window.selectedVehiclesUpdatedAt,
                    };
                  },
                }}
              />
            </div>
            <div className="getStatusBtn" onClick={() => this.getCmdStatus()}>
              Get Status
            </div>
          </div>
          <div
            className="get-download"
            style={{
              width: "40px",
              height: "37px",
              lineHeight: "35px",
              color: "#fff",
              fontFamily: "gotham-b",
              // border: '2px solid #bf3d27',
              fontWeight: "600",
              textAlign: "center",
              fontSize: "13px",
              background: "red",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={this.handleDownload}
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </div>
        </div>
        {/* <div className="tableBody">
          {this.tableData && this.tableData.length ? (
            <GroupTable data={this.tableData} columns={this.selectedCols} />
          ) : this.state.busy ? (
            <div className="it-spinner"></div>
          ) : null}
        </div>
        {this.tableData && this.tableData.length === 0 && !this.state.busy ? (
          <div className="nodata">
            <span>NO DATA</span>
          </div>
        ) : null} */}
               <div className="tableBody">
                    {this.tableData && this.tableData.length ? <GroupTable
                        data={this.tableData}
                        columns={this.selectedCols}
                    /> : this.state.busy ? <div className="it-spinner"></div> : null}
                </div>
                {this.tableData && this.tableData.length ===0 && !this.state.busy ?<div className="nodata">
                            <span>NO DATA</span>
                </div>: null}
      </div>
    );
  }
}

const mapPropsToState = state => {
  return {
    store: state.store,
    vehicleMap: state.vehicleMap,
  };
};

export default connect(mapPropsToState,null,null, { forwardRef: true })(CmdStatusReport);